<template>
  <div>
    <div>
      <div class="mt-4 mx-2">
				<v-row class="mb-2">
					<v-col md="6">
						<div class="text-h5 ml-3 float-left" >
              <v-tooltip top v-if="settings.level>50">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small @click="getData()" v-bind="attrs" fab class="neu-glow float-left mr-5" v-on="on" :loading="loading">
                    <v-icon 
                     large
                      color="info"
                      class="mx-3"
                      active-class="neu-glow-inset"
                      >
                        mdi-sync-circle
                    </v-icon>
                  </v-btn>
                </template>
                <span>Refresh</span>
              </v-tooltip>
							Cauzioni/Anticipi
						</div>
					</v-col>
				</v-row>
        <v-row>
          <v-col cols="12">
            <v-card>
              <v-row dense>
                <v-col cols="12" v-if="$vuetify.breakpoint.mdAndUp">
                  <v-data-table
                    dense
                    fixed-header
                    :headers="headers"
                    :items="deposits||[]"
                    hide-default-footer
                    :items-per-page=500
                    :height="wHeight-235"
                    :loading="loading"
                    no-data-text="Nessun dato presente in archivio"
                    no-results-text="Nessun Risultato estratto"
                    loading-text="Consultazione archivio: attendi..."
                  >
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-tooltip top disable="item.intent=='AUTHORIZE'">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon @click="startRefund(item)" v-bind="attrs" v-on="on" :loading="loading" v-if="item.intent=='CAPTURE'">
                            <v-icon color="info" class="mx-3">
                                mdi-credit-card-refund
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>Rimborsa</span>
                      </v-tooltip>
                    </template>

                  </v-data-table>
                </v-col>
                <v-col cols="12" v-else>
                  <v-data-table
                    dense
                    fixed-header
                    :headers="headers_2"
                    :items="deposits||[]"
                    hide-default-footer
                    :items-per-page=500
                    :height="wHeight-235"
                    :loading="loading"
                    no-data-text="Nessun dato presente in archivio"
                    no-results-text="Nessun Risultato estratto"
                    loading-text="Consultazione archivio: attendi..."
                  >


                  </v-data-table>
                </v-col>                
              </v-row>
            </v-card>
          </v-col>                      
        </v-row>
      </div>
    </div> 
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      page: "Booking",
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      deposits:null,
      loading:false,
      headers: [
                { text: 'Data',       value: 'date',            align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Ore',        value: 'time',            align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Coperti',    value: 'covers',          align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Importo',    value: 'amount',          align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                { text: 'Status',     value: 'status',          align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                { text: 'Canale',     value: 'paymentSource',   align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                { text: 'Modalità',   value: 'intent',          align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                { text: 'Pagato il',  value: 'createdDate',     align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                { text: 'Scadenza 1', value: 'captureExpiry',   align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                { text: 'Scadenza 2', value: 'authorizeExpiry', align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                { text: 'Cognome',    value: 'lastName',        align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
                { text: 'Azione',     value: 'actions',         align: 'center',  sortable: true, class:'pl-1 text-lg-button font-weight-black' },
              ], 
      headers_2: [
                { text: 'Data',       value: 'date',            align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Ore',        value: 'time',            align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
                { text: 'Coperti',    value: 'covers',          align: 'center',  sortable: true, class:'px-1 text-lg-button font-weight-black' },
              ],                    
    };
  },
  computed : {
    ...mapGetters(["settings"]),
  },
  created(){
    this.getData()
  },
  methods:
  {
    async getData()
    {
        {
            this.loading=true;
            try{
                const payload=JSON.stringify({"date": this.date,"action":"Deposits_get"});
                const res = await this.$http.post('/deposits/deposits.php', payload );
                console.log(126,res);
                this.loading= false;
                switch (res.data.errorid)
                {
                  case '0':
                      sessionStorage.setItem('jwt', res.data.jwt);
                      this.deposits=res.data.payloads;
                      console.log(132,this.deposits);
                  break;
                  case '0006':
                      this.$router.push('/auth/login').catch(() => {});
                  break;
                }
                this.loading= false;
            } catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }
        }
    },
    async refundDeposit (item)
    {
        let payload={"action":"Deposits_Refund","payload":JSON.stringify(item)};
        console.log(113,payload)
        const idx=this.deposits.findIndex(m =>m.callId==item.callId)
        console.log(119,idx)
        this.deposits[idx].called=new Date;
        let w= await this.updateDB(payload)
        console.log(122,w);       
        this.snackbar=false;
        if (w.errorid=='0')
        {
            //console.log(126,w.payloads.callId)
            //const idx=this.deposits.findIndex(m =>m.callId==w.payloads.callId)
            //console.log(128,idx)
            //this.deposits[idx].called=new Date;
            //console.log(130,this.deposits)
        }	
    },
    async updateDB(payload){
        try{
            const res = await this.$http.post('/deposits/deposits.php', payload);
            console.log(127,res);
            if (res.data.errorid=='0')
            {
              sessionStorage.setItem('jwt', res.data.jwt);
              if (res.data.payloads)
              {
                  console.log(133);
                  //this.snackbar=true;
              }
            }
            else
            {
              console.log(139);
              //this.$router.push('/auth/login').catch(() => {});
            }
            return res.data;
        } catch(e)
        {
        console.log(e);
        }
    },    
  },
};
</script>
<style scoped>
.v-data-table__mobile-row{
  min-height: 24px!important;
}
</style>